import { memo } from 'react';

import { PrivateWorkspaceAgentGuidedVariantWatermarkImageControl } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/PrivateWorkspaceAgentGuidedVariantWatermarkImageControl';
import { usePrivateWorkspaceAgentWatermarkSelection } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentWatermarkSelection';
import { WorkspaceAgentGuidedVariantWatermarkSettings } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantWatermarkSettings';
import { type WorkspaceAgentGuidedVariantGenerateRequest } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/workspaceAgentGuidedVariantGenerateRequest';

export type PrivateWorkspaceAgentGuidedVariantWatermarkSettingsProps = {
  onGenerate: (request: WorkspaceAgentGuidedVariantGenerateRequest) => void;
};

export const PrivateWorkspaceAgentGuidedVariantWatermarkSettings = memo(
  ({ onGenerate }: PrivateWorkspaceAgentGuidedVariantWatermarkSettingsProps) => {
    const { marginPxMax, watermarkSelection } = usePrivateWorkspaceAgentWatermarkSelection();

    return (
      <WorkspaceAgentGuidedVariantWatermarkSettings
        ImageControl={PrivateWorkspaceAgentGuidedVariantWatermarkImageControl}
        marginPxMax={marginPxMax}
        onGenerate={onGenerate}
        watermarkSelection={watermarkSelection}
      />
    );
  },
);

PrivateWorkspaceAgentGuidedVariantWatermarkSettings.displayName = 'PrivateWorkspaceAgentGuidedVariantWatermarkSettings';
